import { render, staticRenderFns } from "./BoardCalendar.vue?vue&type=template&id=53378b97&"
import script from "./BoardCalendar.vue?vue&type=script&lang=js&"
export * from "./BoardCalendar.vue?vue&type=script&lang=js&"
import style0 from "./BoardCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports